import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserGroupsService {
  private http = inject(HttpClient);

  // Mirrors legacy application_configuration mapping
  private apiServer = environment.authenticationServer;

  // --- Group CRUD ---

  GetGroup(): Promise<any> {
    return firstValueFrom(this.http.get<any>(`${this.apiServer}/api/groups`))
      .then(response => response);
  }

  CreateGroup(group: any): Promise<any> {
    return firstValueFrom(this.http.post<any>(`${this.apiServer}/api/groups`, group));
  }

  UpdateGroup(group: any): Promise<any> {
    return firstValueFrom(this.http.put<any>(`${this.apiServer}/api/groups/${group.id}`, group));
  }

  DeleteGroup(group: any): Promise<any> {
    return firstValueFrom(this.http.delete<any>(`${this.apiServer}/api/groups/${group.id}`));
  }

  // --- Group Users ---

  GetUsersByGroup(groupId: string | number): Promise<any> {
    return firstValueFrom(this.http.get<any>(`${this.apiServer}/api/groups/${groupId}/users`))
      .then(response => response);
  }

  AddGroupUser(groupId: string | number, userId: string | number): Promise<any> {
    return firstValueFrom(this.http.post<any>(`${this.apiServer}/api/groups/${groupId}/user/${userId}`, {}));
  }

  DeleteGroupUser(groupId: string | number, userId: string | number): Promise<any> {
    return firstValueFrom(this.http.delete<any>(`${this.apiServer}/api/groups/${groupId}/user/${userId}`));
  }
}
